import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-logo" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_language_switcher = _resolveComponent("language-switcher")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "burger-menu",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMenu = !_ctx.showMenu))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(['fa', _ctx.showMenu ? 'fa-times' : 'fa-bars', 'burger-menu-icon'])
        }, null, 2)
      ]),
      _createElementVNode("div", {
        class: "logo",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.about && _ctx.about(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.getHeaderLogoImage,
          alt: "Header Logo Image"
        }, null, 8, _hoisted_2)
      ]),
      _createVNode(_component_language_switcher, { class: "language" })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["menu", { 'is-active': _ctx.showMenu }])
    }, [
      _createVNode(_component_router_link, {
        to: "/",
        onClick: _ctx.hideMenu
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('header.prg01')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_router_link, {
        to: "/project2",
        onClick: _ctx.hideMenu
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('header.prg02')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_router_link, {
        to: "/project3",
        onClick: _ctx.hideMenu
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('header.prg03')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_router_link, {
        to: "/about",
        onClick: _ctx.hideMenu
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('header.about')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ], 2)
  ]))
}